import React from "react";
import { Box, Typography, useTheme, useMediaQuery, Button } from "@mui/material";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useThemeMode } from "@/colors";

const StatisticsContainer = styled(Box)`
  padding: 80px 24px;
  background: ${props => props.theme.palette.background.default};
  text-align: center;
  margin-top: 64px;
`;

const ContentWrapper = styled(Box)`
  max-width: 1000px;
  margin: 0 auto;
`;

const StatsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2px;
  margin-top: 48px;
`;

const StatCard = styled(Box)`
  text-align: center;
  padding: 24px;
`;

const StatNumber = styled(Typography)`
  color: ${props => props.theme.palette.text.primary};
  font-weight: 700;
  margin-bottom: 8px;
  background: linear-gradient(
    135deg,
    ${props => props.theme.palette.primary.light} 0%,
    ${props => props.theme.palette.primary.main} 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const StatLabel = styled(Typography)`
  color: ${props => props.theme.palette.text.secondary};
  font-weight: 400;
  line-height: 1.4;
`;

const stats = [
  {
    number: "150k+",
    label: "maps created"
  },
  {
    number: "20",
    label: "personalised styles"
  },
  {
    number: "Up to A1 size",
    label: "prints"
  },
  {
    number: "12+",
    label: "map styles"
  },
  {
    number: "100+",
    label: "frames"
  },
  {
    number: "Unlimited",
    label: "text and frame options"
  },
  {
    number: "3",
    label: "layout options"
  },
  {
    number: "10+",
    label: "pinable locations"
  },
  {
    number: "3",
    label: "text options"
  },
];

export const Statistics: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { colors, mode } = useThemeMode();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StatisticsContainer>
        <Typography 
          variant={"h1"}
          sx={{
            fontSize: isMobile ? '1.5rem' : '2rem',
            fontWeight: 500,
            color: theme.palette.text.primary
          }}
          mb="16px"
        >
          Start mapping your way
        </Typography>
        <Typography 
          variant={"h3"}
          sx={{
            fontSize: isMobile ? '20px !important' : '24px !important',
            fontWeight: 500,
            color: theme.palette.text.secondary,
          }}
        >
          Transform an idea into a map tailored for you.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate("/create")}
          sx={{ maxWidth: "600px", py: "8px", my: "64px", mb: "196px", fontSize: "24px", boxShadow: mode === "light" ? "6px 6px #808080" : undefined  }}
        > Create your map</Button>
      {/* <ContentWrapper>
        <StatsGrid>
          {stats.map((stat, index) => (
            <StatCard key={index}>
              <StatNumber 
                variant={isMobile ? "h3" : "h2"}
                sx={{ 
                  fontSize: isMobile ? '2.5rem' : '3.5rem',
                  lineHeight: 1.1
                }}
              >
                {stat.number}
              </StatNumber>
              <StatLabel 
                variant={isMobile ? "h6" : "h5"}
                sx={{ 
                  fontSize: isMobile ? '1.1rem' : '1.3rem'
                }}
              >
                {stat.label}
              </StatLabel>
            </StatCard>
          ))}
        </StatsGrid>
      </ContentWrapper> */}
    </StatisticsContainer>
  );
};
